var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{staticClass:"fileInput",staticStyle:{"display":"none"},attrs:{"type":"file","id":"fileInput","accept":"image/png, image/jpeg, image/gif"}}),_c('button',{staticClass:"btn btn-outline-secondary",on:{"click":_vm.choose}},[_vm._v("Upload")])])
}
var staticRenderFns = []

export { render, staticRenderFns }